var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentRupee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M36 0H4C1.79086 0 0 1.79086 0 4V36C0 38.2091 1.79086 40 4 40H36C38.2091 40 40 38.2091 40 36V4C40 1.79086 38.2091 0 36 0Z",
    fill: "#146EB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 31.6663C26.4433 31.6663 31.6667 26.443 31.6667 19.9997C31.6667 13.5564 26.4433 8.33301 20 8.33301C13.5567 8.33301 8.33333 13.5564 8.33333 19.9997C8.33333 26.443 13.5567 31.6663 20 31.6663Z",
    stroke: "#146EB4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.76 14.2485C24.76 13.8168 24.4217 13.4668 23.99 13.4668H16.115C15.6833 13.4668 15.3333 13.8168 15.3333 14.2485C15.3333 14.6801 15.6833 15.0301 16.115 15.0301H18.5638C19.58 15.1118 20.4667 15.7768 20.8167 16.7335L20.84 16.8151H16.115C15.6833 16.8151 15.3333 17.1651 15.3333 17.5968L15.345 17.7018C15.3917 18.0868 15.73 18.3785 16.115 18.3785H20.84L20.805 18.4718C20.4433 19.5101 19.4633 20.1985 18.3667 20.1985H16.115C15.905 20.2101 15.7067 20.2918 15.555 20.4435C15.415 20.5951 15.3333 20.7935 15.3333 21.0035C15.3333 21.2018 15.4267 21.4001 15.5783 21.5518L21.2133 26.8835C21.5167 27.1751 22.0183 27.1635 22.31 26.8485L22.3917 26.7435C22.6017 26.4285 22.555 26.0085 22.2867 25.7401L18.075 21.7618H18.3667L18.5883 21.7501C20.3967 21.6568 21.925 20.4201 22.38 18.6585L22.45 18.3785H23.99C24.4217 18.3785 24.76 18.0285 24.76 17.5968V17.4918C24.7017 17.1068 24.375 16.8151 23.99 16.8151H22.4383L22.4267 16.6868C22.2983 16.1385 22.0417 15.6018 21.7033 15.1468L21.6217 15.0301H23.99C24.4217 15.0301 24.76 14.6801 24.76 14.2485Z",
    fill: "#146EB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentRupee);
export default __webpack_public_path__ + "static/media/payment-rupee.a78ce78b7e7fe06b3ebad324caed1533.svg";
export { ForwardRef as ReactComponent };